import { buildConciergePlan } from "../concierge/conciergeEngine";

export function answerGuideQuestion(question, isLoggedIn) {
  const plan = buildConciergePlan(question);
  const actions = plan.actions.map((item) => ({
    id: item.id,
    label: item.label,
    route: item.route,
    requiresAuth: item.requiresAuth,
    requiresConfirmation: item.requiresConfirmation,
    confirmation: item.confirmation,
  }));
  const primary = actions[0] || null;
  return {
    text: plan.summary,
    route: primary?.route || "",
    label: primary?.label || "Ouvrir",
    requiresAuth: Boolean(primary?.requiresAuth && !isLoggedIn),
    requiresConfirmation: Boolean(primary?.requiresConfirmation),
    confirmation: primary?.confirmation || "",
    intent: plan.id,
    suggestions: actions.slice(1),
  };
}
